import React from "react";
import GeeGraphicsSystem from "./GeeGraphicsSystem";
import "./styles.css";

function App() {
  return (
    <div className="App">
      <GeeGraphicsSystem />
    </div>
  );
}

export default App;
